import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';


import TableCell from './tablecell';

import ContainerHeader from '../../../components/ContainerHeader/index';
import CardBox from '../../../components/CardBox/index';
import * as maildetails from '../../../actions/maildetails';

class MailList extends Component {

    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.fetchMailDetailsList();
    }

    render() {
        const { getDataList, match } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        console.log('getDataList', getDataList);
        if (getDataList && getDataList.Status) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (getDataList && getDataList.maildetailsList && getDataList.maildetailsList.length > 0) {
            dataList = getDataList.maildetailsList.map((_data, index) => {
                return (<TableCell key={index} data={_data} index={index} />);
            })
        }

        return (
            <div className="slideInUpTiny ">
            {message}
                <ContainerHeader title="Mail List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <Card className="shadow border-0">
                            <CardHeader className="bg-primary text-white">Mail List</CardHeader>
                            <CardBody>
                                <div className="col-12">
                                    <div className="table-responsive-material">
                                        <table className="default-table table-unbordered table table-lg table-hover">
                                            <thead className="th-border-b">
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Host</th>
                                                    <th>Port</th>
                                                    <th>Username</th>
                                                    <th>SentFrom</th>
                                                    <th>SSL</th>
                                                    <th className="status-cell text-right">Actions</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dataList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
     console.log('state=>', state)
    const { mailDetails } = state
    const { match } = ownProps
    return { getDataList: mailDetails, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(maildetails, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MailList);



// WEBPACK FOOTER //
// ./app/maildetails/maillist/index.js